/**
 * invoiceManager接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const invoiceManager = {
  getInvoiceInfoList (params) {
    return axios.get('/api/InvoiceInfo/GetInvoiceInfoList', { params })
  },
  deleteInvoiceInfo (params) {
    return axios.delete('/api/InvoiceInfo/DeleteInvoiceInfo', { params })
  },
  exportInvoiceInfoList (params) {
    return axios({
      method: 'post',
      url: '/api/InvoiceInfo/ExportInvoiceInfoList',
      data: params,
      responseType: 'blob'
    })
  }
}

export default invoiceManager
